import { useState, useContext } from "react"
import { UserContext } from "../contexts/UserContext"
import { CustomButton } from "../components/global/CustomButton"

export function AddressBook() {
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [address, setAddress] = useState("")
    const [phone, setPhone] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [zip, setZip] = useState("")
    const [country, setCountry] = useState("")
    const [company, setCompany] = useState("")

    const userDataContext = useContext(UserContext)
    const { user } = userDataContext

    return (
        <div className="address-book account-form">
            <h4 className="primary-text mb-5">Address Book</h4>

            <div className="d-flex justify-content-between user-details mt-3">
                <div className="">
                    <div>First Name</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
                <div className="lastname-adress">
                    <div>Last Name</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between user-details my-4">
                <div>
                    <div>Email</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
                <div className="">
                    <div>Phone</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder=""
                    />
                </div>

            </div>

            <div className="user-details my-4">
                <div className="w-100">
                    <div>Address</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder=""
                    />
                </div>
            </div>

            <div className="d-flex justify-content-between user-details mt-3">
                <div className="">
                    <div>City</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                    />
                </div>
                <div className="lastname-adress">
                    <div>State</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-between user-details mt-3">
                <div className="">
                    <div>ZIP Code</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={zip}
                        onChange={(e) => setZip(e.target.value)}
                    />
                </div>
                <div className="lastname-adress">
                    <div>Country</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                    />
                </div>
            </div>

            <div className="user-details my-4">
                <div className="w-100">
                    <div>Company (optional)</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        placeholder=""
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-3 buttons-section">
                <CustomButton
                    color="default"
                    text="Cancel"
                />
                <CustomButton
                    color="primary"
                    text="Save Changes"
                    btnFunction={""}
                />
            </div>
        </div>
    )
}